import * as React from "react";
import * as ReactDOM from "react-dom";
import "./ui/style/index.scss";

import { App } from "./ui/components/app/App";

ReactDOM.render(
    <App />,
    document.getElementById("reactApp")
);